import axiosPublicClient from "../../../../axiosPublicClient"

const service = async (payload) => {
    const result = await axiosPublicClient.post(`/submit-consent-resign`, payload)
    return result.data
}

export default service
